import React from 'react';
import FranchiseeForm from './FranchiseeForm';

const NewFranchiseePage = () => {
    return <FranchiseeForm formType="create" />;
};

export default NewFranchiseePage;

